import React from 'react';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function SectionHeader({ title, light = false, onClose, isEditing = false }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 3 }}>
            <Box
                sx={{
                    flex: 1,
                    height: "52px",
                    pt: 1.5,
                    px: 3,
                    pb: 1.5,
                    borderRadius: "8px",
                    bgcolor: light ? '#E8EAEE' : isEditing ? '#B7BFCC' : '#647490',
                    boxShadow: '-2px 2px 5px 0px #00000040',
                    color: light ? 'black' : isEditing ? '#1F242E' : 'white',
                    fontSize: '24px',
                    fontWeight: 500,
                    fontFamily: 'Roboto',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {title}
            </Box>
            {!isEditing && onClose && (
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        backgroundColor: '#E53935',
                        color: '#FFFFFF',
                        width: 32,
                        height: 32,
                        flexShrink: 0,
                        '&:hover': { backgroundColor: '#C62828' },
                    }}
                >
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            )}
        </Box>
    );
}